import React from "react";
import { useNavigate } from "react-router-dom";
import "./DashboardPdfTools.css";

const PDF_TOOL_GROUPS = [
  {
    eyebrow: "Convert",
    title: "Convert to PDF",
    tools: [
      { emoji: "DOC", title: "Word to PDF", desc: "Convert DOC and DOCX files", path: "/dashboard/word2pdf", color: "#2b5ce6" },
      { emoji: "XLS", title: "Excel to PDF", desc: "Convert XLS and XLSX files", path: "/dashboard/excel2pdf", color: "#1a7a43" },
      { emoji: "PPT", title: "PowerPoint to PDF", desc: "Convert PPT and PPTX files", path: "/dashboard/ppt2pdf", color: "#c84b1e" },
      { emoji: "IMG", title: "Image to PDF", desc: "Convert images into a PDF", path: "/dashboard/image2pdf", color: "#7b3fe4" },
    ],
  },
  {
    eyebrow: "Organize",
    title: "Arrange PDF pages",
    tools: [
      { emoji: "MRG", title: "Merge PDF", desc: "Combine multiple PDF files", path: "/dashboard/merge", color: "#6366f1" },
      { emoji: "SPL", title: "Split PDF", desc: "Extract selected pages", path: "/dashboard/split", color: "#0891b2" },
      { emoji: "ORD", title: "Rearrange PDF", desc: "Change page order", path: "/dashboard/rearrange", color: "#0891b2" },
    ],
  },
  {
    eyebrow: "Optimize",
    title: "Improve PDF files",
    tools: [
      { emoji: "ZIP", title: "Compress PDF", desc: "Reduce PDF file size", path: "/dashboard/compress", color: "#1a7a43" },
      { emoji: "OCR", title: "OCR PDF", desc: "Extract text from PDFs", path: "/dashboard/ocr", color: "#7b3fe4" },
    ],
  },
  {
    eyebrow: "Secure",
    title: "Sign and protect",
    tools: [
      { emoji: "SIG", title: "E-sign PDF", desc: "Add signatures and stamps", path: "/dashboard/esign", color: "#c84b1e" },
      { emoji: "KEY", title: "Add Password", desc: "Protect a PDF file", path: "/dashboard/addpass", color: "#e5322d" },
      { emoji: "UNL", title: "Remove Password", desc: "Unlock protected PDFs", path: "/dashboard/removepass", color: "#e5322d" },
    ],
  },
];

const DashboardPdfTools = () => {
  const navigate = useNavigate();

  return (
    <div className="dpt-root">
      <div className="dpt-hero">
        <div>
          <span className="dpt-eyebrow">PDF Tools</span>
          <h1>Choose a PDF tool</h1>
          <p>Convert, organize, optimize, sign, and secure PDFs from one clean workspace.</p>
        </div>
      </div>

      <div className="dpt-groups">
        {PDF_TOOL_GROUPS.map((group) => (
          <section key={group.eyebrow} className="dpt-section">
            <div className="dpt-section-head">
              <span>{group.eyebrow}</span>
              <h2>{group.title}</h2>
            </div>
            <div className="dpt-grid">
              {group.tools.map((tool) => (
                <button
                  key={tool.path}
                  type="button"
                  className="dpt-card"
                  onClick={() => navigate(tool.path)}
                >
                  <span className="dpt-card-icon" style={{ background: `${tool.color}12`, color: tool.color }}>
                    {tool.emoji}
                  </span>
                  <span className="dpt-card-body">
                    <strong>{tool.title}</strong>
                    <small>{tool.desc}</small>
                  </span>
                  <svg className="dpt-arrow" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </button>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default DashboardPdfTools;
